<div *ngIf="!addContactEnabled" class="flex flex-col full-grow-no-shrink-no-basis">
  <div class="component-heading flex flex-row justify-start items-center">New Conversation</div>
  <div class="action-heading flex flex-row justify-between items-center">
    <a class="link-color" (click)="navigateToConversationList()"
       particleAnalytics
       analyticsCategory="new-conversation"
       analyticsAction="cancel-btn">Cancel</a>
    <a class="link-color" (click)="navigateToConversation()"
       particleAnalytics
       analyticsCategory="new-conversation"
       analyticsAction="next-btn">Next</a>
  </div>
  <div class="add-user-section flex flex-row justify-start items-center">

    <a class="link-color" (click)="addConatacs()"
       particleAnalytics
       analyticsCategory="add-contact"
       analyticsAction="add-contact">
      <i class="far fa-user-plus m-r-7"></i>
      <span>Add Contact</span>
    </a>
  </div>
  <contact-selector (selectedItemsChanged)="onSelectionChanged($event)"></contact-selector>
</div>
<particle-conversation-add-contact *ngIf="addContactEnabled"
                                   (addContactAction)="onAddContactAction($event)"></particle-conversation-add-contact>
